import { useCallback, useEffect, useMemo, useState } from 'react';
import useApi from '../../hooks/useApi';
import { BootResponse } from '../../constants/apiResponses.types';
import './style.scss';
import { useNavigate } from 'react-router-dom';
import {
  EBundlesInternalViewModel,
  EEventsType,
  EFeatureFlag,
  ELocalStorageKeys,
  EStorePhase,
  ESupportType,
} from '../../constants/enums';
import useCustomEvents from '../../hooks/useCustomEvents';

import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import LanguagePicker from '../LanguagePicker/LanguagePicker';
import { useLocalizationState } from 'state/hooks/localization.state.hook';
import { loginPageService } from '../../pages/login/login-page.service';
// import { useSupportButton } from 'hooks/useSupportButton';
// import { SUPPORT_IFRAME, SUPPORT_IFRAME_LAUNCHER } from 'pages/Shop/utils';
import { StyledLogoContainer } from './style';
import { useAppState } from 'state/hooks/app.state.hook';
import { webStorageUtil } from 'state/webStorage.state.service';
import { buildRefundUrl, buildSupportUrl } from '../../utils';
import CookieSettingsDialog from 'components/CookieSettingsDialog/CookieSettingsDialog';
import { Footer as FooterShared } from '@appcharge/shared-ui';
import { useStoreSettings } from '../../hooks/useStoreSettings';
import { useStoreBrand } from 'state/AuthBoot/AuthBootContext';
const privacyPolicyLinkProductMadness = 'https://www.productmadness.com/privacy-notice';
const termsAndConditionsLinkProductMadness = 'https://www.productmadness.com/terms-of-service';

export const Footer: React.FC = () => {
  const [isLoginPage, setIsLoginPage] = useState<boolean>(false);
  const [showCookieSettings, setShowCookieSettings] = useState<boolean>(false);
  const API = useApi({});
  const publisherMetaData = API.getPublisherMeta.data as BootResponse;
  const storeBrand = useStoreBrand();
  const navigate = useNavigate();
  const { openInfoModal } = useAppState();
  const customEvents = useCustomEvents();
  const [isProductMadness, setIsProductMadness] = useState(false);
  const [isOldVersion, setIsOldVersion] = useState(false);
  const { footer: footerSettings } = useStoreSettings();

  const logoImageSrc = isMobile ? footerSettings.imageMobile : footerSettings.imageDesktop;

  useEffect(() => {
    if (webStorageUtil.get(ELocalStorageKeys.SESSION_TOKEN)) {
      setIsLoginPage(false);
    } else {
      setIsLoginPage(true);
    }
  }, [webStorageUtil.get(ELocalStorageKeys.SESSION_TOKEN)]);

  // const { openSupportButton } = useSupportButton({
  //   postLoginSnippet: publisherMetaData.supportConfiguration?.postLoginSnippet,
  // });
  // useEffect(() => {
  //   const checkIframeVisibility = () => {
  //     const iframe = document.getElementById('hs-web-sdk-iframe');
  //     if (iframe && window.getComputedStyle(iframe).visibility === 'visible') {
  //       return true;
  //     }
  //     return false;
  //   };

  //   const loadSupportScript = () => {
  //     if (document.getElementById('postlogin-support-script')) {
  //       document.getElementById('postlogin-support-script')?.remove();
  //     }
  //     const scriptUrl = publisherMetaData.supportConfiguration?.postLoginSnippet;
  //     const alreadyExists =
  //       checkIframeVisibility() ||
  //       (scriptUrl && !!document.querySelector(`script[src="${scriptUrl}"]`));

  //     if (!scriptUrl || alreadyExists || isLoginPage) {
  //       setIsScriptLoaded(true);
  //       return;
  //     }

  //     const script = document.createElement('script');
  //     script.src = scriptUrl;
  //     script.id = 'postlogin-support-script';
  //     script.onload = () => {
  //       const helpshift = window as any;
  //       if (helpshift.Helpshift && typeof helpshift.Helpshift === 'function') {
  //         helpshift.Helpshift('init');
  //       }
  //       const intervalId = setInterval(() => {
  //         const didLoadSupportIframe = checkIframeVisibility();
  //         if (didLoadSupportIframe) {
  //           setIsScriptLoaded(true);
  //           clearInterval(intervalId);
  //         }
  //       }, 100);
  //     };
  //     document.body.appendChild(script);

  //     return script;
  //   };

  //   loadSupportScript();

  //   return () => {
  //     const supportButton = document.getElementById(SUPPORT_IFRAME);
  //     if (supportButton) {
  //       supportButton.remove();
  //     }
  //     const supportIframe = document.getElementById(SUPPORT_IFRAME_LAUNCHER);
  //     if (supportIframe) {
  //       supportIframe.remove();
  //     }
  //     const supportScript = document.querySelector(
  //       `script[src="${publisherMetaData?.supportConfiguration?.postLoginSnippet}"]`
  //     );
  //     if (supportScript) {
  //       supportScript.remove();
  //     }
  //     const middlewareScripts = document.querySelectorAll('script[src]');

  //     const scriptUrlPattern = 'https://webchat.helpshift.com/latest';
  //     middlewareScripts.forEach((s) => {
  //       if ((s as HTMLScriptElement).src.includes(scriptUrlPattern)) {
  //         s.remove();
  //       }
  //     });
  //   };
  // }, [publisherMetaData?.supportConfiguration?.postLoginSnippet, location, isLoginPage]);

  useEffect(() => {
    if (loginPageService.checkIfOlderOsVersions()) {
      setIsOldVersion(true);
    }
  }, []);

  const showAppchargeLogo =
    typeof footerSettings?.showAppchargeLogo === 'string'
      ? footerSettings.showAppchargeLogo !== 'false'
      : (footerSettings?.showAppchargeLogo ?? true);

  const { t } = useTranslation();

  const { languagesList } = useLocalizationState();
  const supportMultiLanguageEnabled = publisherMetaData.featureFlags.store_multi_language_support;

  const getFooterVersion = useCallback(() => {
    if (!process.env.REACT_APP_STORE_VERSION || !process.env.REACT_APP_SHARED_UI_VERSION) {
      return '';
    }
    const version =
      process.env.REACT_APP_STORE_VERSION?.replace('HF', '') +
        process.env.REACT_APP_SHARED_UI_VERSION?.replace('HF', '') || '';
    return version ? `v${version}` : '';
  }, [publisherMetaData]);

  useEffect(() => {
    setIsProductMadness(
      [
        EBundlesInternalViewModel.JACKPOT_SLOTS,
        EBundlesInternalViewModel.BIG_FISH_CASINO,
        EBundlesInternalViewModel.CASHMAN_CASINO,
        EBundlesInternalViewModel.LIGHTNING_LINK_CASINO,
        EBundlesInternalViewModel.MIGHTY_FU_CASINO,
        EBundlesInternalViewModel.HEART_OF_VEGAS,
        EBundlesInternalViewModel.LIGHTNING_LINK_CASINO2,
        EBundlesInternalViewModel.DYNAMIC_HEART_OF_VEGAS,
        EBundlesInternalViewModel.DYNAMIC_MIGHTY_FU_CASINO,
        EBundlesInternalViewModel.DYNAMIC_CASH_MAN_CASINO,
      ].includes(storeBrand as EBundlesInternalViewModel)
    );
  }, [storeBrand]);

  const isJunesJourney = useMemo(
    () => storeBrand === EBundlesInternalViewModel.JUNES_JOURNEY,
    [storeBrand]
  );

  const isCandyCrush = useMemo(
    () => storeBrand === EBundlesInternalViewModel.CANDY_CRUSH,
    [storeBrand]
  );

  const openInNewTab = footerSettings?.openLinksInNewTab || false;

  const handleSupportClick = () => {
    // if (!isScriptLoaded) {
    //   return;
    // }

    const phase: EStorePhase = isLoginPage ? EStorePhase.PRE_LOGIN : EStorePhase.POST_LOGIN;
    const supportType: ESupportType = isLoginPage
      ? ESupportType.PRE_LOGIN
      : ESupportType.POST_LOGIN;

    customEvents.sendCustomEvent(
      EEventsType.SUPPORT_FORM_OPEN,
      {
        phase,
        supportModel: publisherMetaData.supportConfiguration?.supportModel,
      },
      phase
    );

    if (footerSettings.supportLink) {
      const supportUrl = buildSupportUrl(footerSettings.supportLink, footerSettings.supportParams);

      if (openInNewTab) {
          window.open(supportUrl, '_blank');
      } else {
          openInfoModal(supportUrl);
      }
      return;
    }

    navigate(`/support/${supportType}/${phase}`);
  };

  const playerData = webStorageUtil.get(ELocalStorageKeys.PLAYER_DATA);
  const playerCountry = playerData?.playerCountry || undefined;
  const showRefundLink =
    !!publisherMetaData.featureFlags[EFeatureFlag.EU_REFUND_LINK_ENABLED] &&
    !isLoginPage &&
    !!playerCountry &&
    !!footerSettings.enableRefundFooterLink &&
    !!footerSettings.enabledRefundFooterLinkCountries?.includes(playerCountry);
  const refundUrl = useMemo(() => {
    if (!showRefundLink) return undefined;
    return buildRefundUrl(
      playerData?.playerId,
      publisherMetaData.storeTheme.publisherId,
      playerCountry
    );
  }, [
    showRefundLink,
    playerData?.playerId,
    publisherMetaData.storeTheme.publisherId,
    playerCountry,
  ]);

  const shouldDisplayLanguagePicker =
    supportMultiLanguageEnabled && languagesList && languagesList?.length > 1;

  const showVersion = useMemo(
    () => publisherMetaData.featureFlags[EFeatureFlag.STORE_SHOW_VERSION],
    [publisherMetaData.featureFlags]
  );

  return (
    <>
      <FooterShared
        publisherMetaData={publisherMetaData}
        isProductMadness={isProductMadness}
        isLoginPage={isLoginPage}
        isMobile={isMobile}
        isOldVersion={isOldVersion}
        showVersion={showVersion}
        showAppchargeLogo={showAppchargeLogo}
        getFooterVersion={getFooterVersion}
        openInfoModal={openInfoModal}
        openInNewTab={openInNewTab}
        t={t}
        privacyPolicyLinkProductMadness={privacyPolicyLinkProductMadness}
        termsAndConditionsLinkProductMadness={termsAndConditionsLinkProductMadness}
        logoImageSrc={logoImageSrc}
        footerSettings={footerSettings}
        isJunesJourney={isJunesJourney}
        isCandyCrush={isCandyCrush}
        shouldDisplayLanguagePicker={shouldDisplayLanguagePicker}
        handleSupportClick={handleSupportClick}
        LanguagePicker={LanguagePicker}
        StyledLogoContainer={StyledLogoContainer}
        handleCookieSettings={() => setShowCookieSettings(true)}
        showRefundLink={showRefundLink}
        refundUrl={refundUrl}
      />
      <CookieSettingsDialog
        open={showCookieSettings}
        onClose={() => setShowCookieSettings(false)}
        variant="modal"
      />
    </>
  );
};
